import { Api } from "@/plugins/api"

export const findByNumeroReconnaissance = (numeroReconnaissance) => {
  return Api.get("/formations-reconnues/find-by-numero-reconnaissance?numeroReconnaissance=" + numeroReconnaissance)
}